import React, {Suspense, useState} from "react";
import {auth} from "./utils/firebaseApp";
import {ThemeProvider} from "@mui/material";
import {theme} from "./config/Theme";
import {Navigate, Route, Routes} from "react-router-dom";
import {AppContextProvider} from "./utils/AppContext";
import LoadingScreen from "./shared-components/loading/LoadingScreen";
import {LoginPage} from "./pages/login-page/login-page";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {MainLayout} from "./layout/main-layout/MainLayout";
import TicketScanner from "./pages/qr-code-scanner/TicketScanner";
import {onAuthStateChanged} from "firebase/auth";
import IndexPage from "./pages/index-page/IndexPage";
import StandPage from "./pages/BarPage";
import AddCash from "./pages/AddCash";
import ChargePage from "./pages/ChargePage";
import GodPage from "./pages/GodPage";
import AdminPage from "./pages/AdminPage";
import CreateWallet from "./pages/wallet/CreateWallet";
import {LoginPageWalletUsers} from "./pages/login-page/login-page-wallet-users";
import Wallet from "./pages/wallet/Wallet";


function Index() {
    const [user, setUser] = useState(false)

    onAuthStateChanged(auth, async (user) => {
        console.log('user')
        console.log(user)
        if (user) {
            console.log('user exists')
            setUser(true)
        }
    })

    return (
        <div className='App'>
            <ThemeProvider theme={theme}>
                <AppContextProvider>
                    <Suspense fallback={<LoadingScreen/>}>
                        {/*//TODO add layout*/}
                        <Routes>
                            {!user ?
                                <>
                                    {/*<Route path="/wallet/:eventName" index element={<LoginPageWalletUsers user={user}/>}/>*/}
                                    {/*<Route path="/wallet" index element={<LoginPageWalletUsers user={user}/>}/>*/}
                                    <Route path="/login" index element={<LoginPage user={user}/>}/>
                                    <Route path="*" element={<Navigate to="/login"/>}/>
                                    {/*<Route path="/" index element={<LoadingScreen/>}/>*/}
                                </>
                                :
                                <>
                                    <Route path="/" index element={<IndexPage/>}/>
                                    <Route path="/projects" index element={<MainLayout>Projects</MainLayout>}/>
                                    <Route path="/ticketScanner" index element={<TicketScanner/>}/>
                                    <Route path="/addCash" index element={<AddCash/>}/>
                                    <Route path="/stand" index element={<StandPage/>}/>
                                    <Route path="/charge" index element={<ChargePage/>}/>
                                    {/*<Route path="/wallet" index element={<Wallet/>}/>*/}
                                    {/*<Route path="/add-wallet" index element={<CreateWallet/>}/>*/}
                                    <Route path="/admin" index element={<AdminPage/>}/>
                                    <Route path="/god" index element={<GodPage/>}/>
                                    <Route path="*" element={<Navigate to="/"/>}/>
                                </>
                            }
                        </Routes>
                    </Suspense>
                </AppContextProvider>
            </ThemeProvider>
            <ToastContainer/>
        </div>
    );
}

export default Index;
